import { ApplicationTypes } from '@/models/ApplicationType';
import { PartnerYearsRecognized } from '@/models/PartnerYearsRecognized';
import { ProgramNames } from '@/models/Program';

export const YearsRecognizedByProgram = (
  partnerYearsRecognized: PartnerYearsRecognized[],
  program: ProgramNames,
  applicationType: ApplicationTypes = ApplicationTypes.Standard
): number => {
  if (partnerYearsRecognized == null || partnerYearsRecognized.length === 0) return 0;

  const tempValue =
    partnerYearsRecognized.filter(
      (pyr: PartnerYearsRecognized) =>
        pyr.applicationTypeId === applicationType && pyr.programId === program
    )?.length ?? 0;

  return tempValue;
};

// util for finding out if the partner has been recognized for a certain year
export const hasBeenRecognizedForYear = (
  partnerYearsRecognized: PartnerYearsRecognized[],
  program: ProgramNames,
  applicationType: ApplicationTypes,
  applicationCycleId: number
): boolean => {
  if (partnerYearsRecognized == null || partnerYearsRecognized.length === 0) return false;

  const tempValue =
    partnerYearsRecognized.filter(
      (pyr: PartnerYearsRecognized) =>
        pyr.applicationTypeId === applicationType &&
        pyr.programId === program &&
        pyr.applicationCycleId === applicationCycleId
    )?.length ?? 0;

  return tempValue > 0;
};
